<div class="container">
  <div class="card border-0 overflow-hidden">
    <div class="card-body p-4 bg-light">
      <h4 class="mb-4 fw-bold"> Tipologie articoli  </h4>

      @if (listTipiArticoli) {
        <div class="list-group">
          @for (item of listTipiArticoli; track item) {
            <div
              class="list-group-item d-flex align-items-center rounded-3 mb-1 shadow-sm border-0"
              [class.presente]="isPresente(item.id)"
              [class.assente]="!isPresente(item.id)"
              >
              <!-- Icona stato -->
              @if (isPresente(item.id)) {
                <i
                  class="fa fa-check text-success me-3  fa-l"
                ></i>
              } @else {
                <i class="fa fa-times text-muted fa-l"></i>
              }
              <!-- Nome categoria -->
              <span class="fw-semibold fs-6">{{ item.descrizione }}</span>
            </div>
          }
        </div>
      }
    </div>
  </div>
</div>
